import { GalleryPage } from "./gallery/GalleryPage";

/**
 * Builder's ``/components`` route: the single component gallery (Fase D,
 * D11 + D28): the kit, bi-components, dashboard-render and admin-ui in one
 * catalog, inside the builder's shell. See ``pages/gallery/``. The old
 * ``ShowcaseGallery`` of dashboard-render covered only the BI widgets.
 */
export function ComponentsGalleryPage(): JSX.Element {
  return <GalleryPage />;
}
